import { lazy } from 'react'
import { Route, Switch } from '@hfs/react-router'
import { getRoute } from '@hfs/website/utils/getRoute'

export const InvestRoutes = () => (
  <Switch>
    <Route
      component={lazy(async () => {
        const { Invest } = await import(
          /* webpackPrefetch: true, webpackChunkName: "Homepage" */ '@hfs/website/react/pages/public/Invest'
        )

        return {
          default: Invest,
        }
      })}
      exact
      path={getRoute('/invest')}
    />
  </Switch>
)
